import { useState } from 'react'
import type { NavigationItem } from '../domain/landing.types'
import { CloseIcon, MenuIcon } from '../../../shared/ui/icons'
import { useScrollState } from '../../../shared/hooks/useScrollState'

const logoUrl = '/brand/CuervoBlanco_LogoCompleto_Cropped_Transparent.svg'

type HeaderProps = {
  navigation: NavigationItem[]
}

export function Header({ navigation }: HeaderProps) {
  const [isOpen, setIsOpen] = useState(false)
  const isScrolled = useScrollState()

  return (
    <header className={`site-header${isScrolled ? ' site-header--scrolled' : ''}`}>
      <a className="brand-lockup" href="#top" aria-label="Cuervo Blanco — inicio">
        <span className="brand-lockup__viewport">
          <img src={logoUrl} alt="Cuervo Blanco — Semillas y Alimentos" />
        </span>
      </a>

      <nav className="desktop-nav" aria-label="Navegación principal">
        {navigation.map((item) => (
          <a key={item.href} href={item.href}>{item.label}</a>
        ))}
      </nav>

      <div className="header-actions">
        <a className="header-contact-action" href="#cotizar">Cotizar</a>
        <button
          className="icon-button header-actions__mobile"
          type="button"
          aria-label={isOpen ? 'Cerrar menú' : 'Abrir menú'}
          aria-expanded={isOpen}
          aria-controls="mobile-navigation"
          onClick={() => setIsOpen((value) => !value)}
        >
          {isOpen ? <CloseIcon /> : <MenuIcon />}
        </button>
      </div>

      {isOpen && (
        <nav className="mobile-nav" id="mobile-navigation" aria-label="Navegación móvil">
          {navigation.map((item) => (
            <a key={item.href} href={item.href} onClick={() => setIsOpen(false)}>{item.label}</a>
          ))}
          <a href="#cotizar" onClick={() => setIsOpen(false)}>Cotizar</a>
        </nav>
      )}
    </header>
  )
}
